var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_14-linkedin",
    "data-name": "14-linkedin",
    transform: "translate(-7.5 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 18,
    height: 19,
    rx: 6,
    transform: "translate(7.5 8)",
    fill: "#007fb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_73",
    "data-name": "Groupe 73",
    transform: "translate(10.458 10.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_74",
    "data-name": "Groupe 74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 2.227,
    height: 8.068,
    transform: "translate(0.279 3.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M31.218,22.955a2.943,2.943,0,0,0-3.339,1.026V22.955H25.66v8.068h2.219V26.767a2.084,2.084,0,0,1,.55-1.46,1.171,1.171,0,0,1,.841-.412,1.336,1.336,0,0,1,.971.392,1.511,1.511,0,0,1,.419,1.073v4.663h2.505v-5A2.961,2.961,0,0,0,31.218,22.955Z",
    transform: "translate(-21.271 -19.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 1.391,
    cy: 1.391,
    r: 1.391,
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.3abe35dbc00dc17cf2a56768b1769ce5.svg";
export { ForwardRef as ReactComponent };